// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"styles_skeleton__tcGi6","Animation":"styles_Animation__IzjvQ"};